module.exports = __webpack_public_path__ + "img/play_process.20f5e307.png";